<template>
  <detail-page>
    <template #title>
      <div class="title"></div>
    </template>
    <template #content>
      <tab-list />
    </template>
  </detail-page>
</template>

<script>
import DetailPage from '@/views/pc/components/detailPage/Index.vue'
import TabList from './components/TabList.vue'

export default {
  name: 'PcList',
  components: {
    DetailPage,
    TabList,
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 192px;
  background-position: center;
  background: url('~@/assets/img/pc/title.png') no-repeat;
  background-position: center 0;
}
</style>